import {BagSvg} from './BagSvg';
import {UserSvg} from './UserSvg';
import {GiftSvg} from './GiftSvg';
import {MailSvg} from './MailSvg';
import {HeartSvg} from './HeartSvg';
import {CheckSvg} from './CheckSvg';
import {EyeOffSvg} from './EyeOffSvg';
import {EyeSvg} from './EyeSvg';
import {GoBackSvg} from './GoBackSvg';
import {SearchSvg} from './SearchSvg';
import {DeleteSvg} from './DeleteSvg';
import {LogOutSvg} from './LogOutSvg';
import {BasketSvg} from './BasketSvg';
import {BurgerSvg} from './BurgerSvg';
import {MapPinSvg} from './MapPinSvg';
import {ViewAllSvg} from './ViewAllSvg';
import {HomeTabSvg} from './HomeTabSvg';
import {FiltersSvg} from './FiltersSvg';
import {ReadMoreSvg} from './ReadMoreSvg';
import {BigHeartSvg} from './BigHeartSvg';
import {OrderTabSvg} from './OrderTabSvg';
import {CalendarSvg} from './CalendarSvg';
import {ModalMailSvg} from './ModalMailSvg';
import {SortingBySvg} from './SortingBySvg';
import {PhoneCallSvg} from './PhoneCallSvg';
import {InputCheckSvg} from './InputCheckSvg';
import {ProfileTabSvg} from './ProfileTabSvg';
import {SmartPhoneSvg} from './SmartPhoneSvg';
import {RightArrowSvg} from './RightArrowSvg';
import {WishlistBagSvg} from './WishlistBagSvg';
import {CategoryTabSvg} from './CategoryTabSvg';
import {RepeatOrderSvg} from './RepeatOrderSvg';
import {WishlistTabSvg} from './WishlistTabSvg';
import {LeaveAReviewSvg} from './LeaveAReviewSvg';
import {RememberCheckSvg} from './RememberCheckSvg';
import {PromocodeAppliedSvg} from './PromocodeAppliedSvg';

import AddSvg from './AddSvg';
import TagSvg from './TagSvg';
import StarSvg from './StarSvg';
import CopySvg from './CopySvg';
import GoogleSvg from './GoogleSvg';
import CameraSvg from './CameraSvg';
import ServerSvg from './ServerSvg';
import TwitterSvg from './TwitterSvg';
import FacebooSvg from './FacebooSvg';
import RatingStarSvg from './RatingStarSvg';
import ReviewStarSvg from './ReviewStarSvg';
import {RemoveSvg} from './RemoveSvg';
import {ChangePasswordSvg} from './ChangePasswordSvg';

export const svg = {
  BagSvg,
  UserSvg,
  GiftSvg,
  RemoveSvg,
  MailSvg,
  HeartSvg,
  CheckSvg,
  CameraSvg,
  EyeOffSvg,
  EyeSvg,
  GoBackSvg,
  LogOutSvg,
  BurgerSvg,
  BasketSvg,
  MapPinSvg,
  DeleteSvg,
  SearchSvg,
  ViewAllSvg,
  HomeTabSvg,
  FiltersSvg,
  CalendarSvg,
  OrderTabSvg,
  BigHeartSvg,
  ReadMoreSvg,
  ModalMailSvg,
  SortingBySvg,
  PhoneCallSvg,
  InputCheckSvg,
  RightArrowSvg,
  SmartPhoneSvg,
  ProfileTabSvg,
  CategoryTabSvg,
  RepeatOrderSvg,
  WishlistTabSvg,
  WishlistBagSvg,
  LeaveAReviewSvg,
  RememberCheckSvg,
  PromocodeAppliedSvg,

  TagSvg,
  AddSvg,
  StarSvg,
  CopySvg,
  GoogleSvg,
  ServerSvg,
  TwitterSvg,
  FacebooSvg,
  ReviewStarSvg,
  RatingStarSvg,
  ChangePasswordSvg,
};
